var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70%",
    height: "70%",
    viewBox: "0 0 83 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4484_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.9912 0H64.2763V14.7172H49.3505V28.5307H34.0624V44.9262H17.1953V63H82.4769L81.9912 0Z",
    fill: "#24514A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8455 60.6757C10.363 60.6757 13.2144 57.9013 13.2144 54.4789C13.2144 51.0566 10.363 48.2822 6.8455 48.2822C3.32803 48.2822 0.476562 51.0566 0.476562 54.4789C0.476562 57.9013 3.32803 60.6757 6.8455 60.6757Z",
    fill: "#24514A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4484_360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 63,
    fill: "white",
    transform: "translate(0.476562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrave);
export default __webpack_public_path__ + "static/media/grave.3a5d847ad60f2f8dc677d62da53963e3.svg";
export { ForwardRef as ReactComponent };